import { IClip, TClip } from "MVVM/@types";
import { getMapThumbnail } from "MVVM/Utilities/Clip";

export const buildIframeOptions = (): {
  controls: boolean;
  fluid: boolean;
  autoplay: boolean;
  muted: boolean;
  defaultVolume: number;
  inline: boolean;
  shouldLoop: boolean;
  useOpenGraphImage: boolean;
} => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const background = params.get("background");

  const autoplay = params.get("autoplay");
  const volume = Number(params.get("volume")) ?? 1;
  const muted = params.get("muted");

  const shouldAutoplay =
    [autoplay, background].includes("true") || autoplay !== "false";
  const shouldMute =
    muted === "false" && !shouldAutoplay ? false : shouldAutoplay;
  const shouldAllowInlinePlayback = !!params.get("inline");
  const showControls = !background;
  const poster = params.get("pi");

  return {
    controls: showControls,
    fluid: false,
    autoplay: shouldAutoplay,
    muted: shouldMute,
    defaultVolume: volume,
    inline: shouldAllowInlinePlayback,
    shouldLoop: !!background || params.get("loop") === "true",
    useOpenGraphImage: poster === "og",
  };
};

export const shouldRenderSubtitle = (height: number) => {
  if (height <= 550) return false;

  return true;
};

export const shouldRenderTitle = (height: number) => {
  if (height <= 550) return false;

  return true;
};

export const getNumMomentsToRender = (height: number) => {
  if (height > 700) return 3;
  if (height <= 400) return 1;
  if (height <= 700) return 2;

  return 1;
};

export const getWidgetWidth = (width: number) => {
  if (width > 1024) return "50%";
  if (width <= 425) return "70%";
  if (width <= 1024) return "75%";

  return "90%";
};
